import { useEffect } from "react";
import "./App.css";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { changeLanguage } from "./redux/Reducers/GeneralReducer";
import { strings } from "./utils/constants";
// COMMENTED OUT: Login functionality removed - app now accessible without login
// import LoginPage from "./pages/User/Login";
import ThemeProvider from "./theme";
import ScrollToTop from "./component/ScrollToTop";
import Router from "./routes";
import Dashboard from "./pages/User/Dashboard";
import SearchForm from "./pages/User/SearchForms";
// COMMENTED OUT: My Profile functionality removed as per user request
// import MyProfile from "./pages/User/MyProfile";
// COMMENTED OUT: Routes removed as per image requirements - only keeping essential pages
// import Aboutus from "./pages/User/AboutUs";
// import DemoTraining from "./pages/User/DemoTraining";
import ContactUs from "./pages/User/ContactUs";
import TermsOfUse from "./pages/User/TermsOfUse";
// import Billing from "./pages/User/Billing";
import NotFound from "./pages/User/404";
// import SubscriptionPlan from "./pages/User/SubscriptionPlan";
import AccessADA from "./pages/User/AccessADA";
import { useCookies } from "react-cookie";
// import FreeSubscription from "./pages/User/SubscriptionPlan/FreeSubscription";
import { paths } from "./utils/constants";
import { logWebAccess } from "./services/accessLogger";
import { captureSource } from "./services/source";


const App = () => {
  const navigation = useNavigate();
  const loc = useLocation();
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const [cookies] = useCookies([
    "admin_access_token",
    "admin_refresh_token",
  ]);
  useEffect(() => {
    const adminCookie = cookies.admin_access_token;
    if (loc.pathname.includes("admin")) {
      if (!adminCookie) {
        navigation(paths.adminRoutes.ADMIN);
      }
    }
    // COMMENTED OUT: User authentication check removed - app now accessible without login
    // else {
    //   if (!cookie) {
    //     navigation("/");
    //   }
    // }
  }, [
    cookies.admin_access_token,
    loc.pathname,
    navigation,
  ]);

  useEffect(() => {
    const searchParams = new URLSearchParams(loc.search);
    const urlLang = searchParams.get('lang');
    // Detect the existing source (?source= / ?utm_source= / external referrer)
    // AND retain it for the session so it can be reused later (e.g. when
    // launching the Desktop app from the Access ADA page).
    const source = captureSource(searchParams);

    // An explicit ?lang= still switches the UI language.
    let appLang;
    if (urlLang) {
      appLang = urlLang === 'fr' ? strings.language.FR : strings.language.EN;
      i18n.changeLanguage(appLang);
      dispatch(changeLanguage(appLang));
    } else {
      appLang = i18n.language.includes(strings.language.FR)
        ? strings.language.FR
        : strings.language.EN;
    }

    // Log the web access whenever we have a source. This now covers links like
    // ?utm_source=chatgpt.com even when no ?lang= is present, as well as the
    // existing external-referrer case.
    if (source) {
      logWebAccess(appLang, source);
    }
  }, [loc.search, dispatch, i18n, loc.pathname]);

  // COMMENTED OUT: Unauthorized user handling removed - no login required
  // const unAuthorized = localStorage.getItem("unAuthorized");
  // useEffect(() => {
  //   if (unAuthorized === "user") {
  //     removeCookie("access_token", { path: "/" });
  //     removeCookie("refresh_token", { path: "/" });
  //     navigation(0);
  //     navigation("/", { replace: true });
  //     localStorage.removeItem("unAuthorized");
  //   } else if (unAuthorized === "admin") {
  //     removeCookie("admin_access_token", {
  //       path: paths.adminRoutes.ADMIN,
  //     });
  //     removeCookie("admin_refresh_token", {
  //       path: paths.adminRoutes.ADMIN,
  //     });
  //     navigation(paths.adminRoutes.ADMIN, { replace: true });
  //     localStorage.removeItem("unAuthorized");
  //   }
  // }, [unAuthorized]);

  if (loc.pathname.includes("admin")) {
    return (
      <ThemeProvider>
        <ScrollToTop />
        <Router />
      </ThemeProvider>
    );
  } else {
    // COMMENTED OUT: Token check removed - app accessible without login
    // const token = cookies.access_token;
    // COMMENTED OUT: No token check needed - all users can access all pages
    // if (token) {
    return (
      <Routes>
        {/* COMMENTED OUT: Login page removed - users go directly to dashboard */}
        {loc.pathname === "/" && <Route path="/" element={<Dashboard />} />}
        <Route path={paths.userRoutes.DASHBOARD} element={<Dashboard />} />
        <Route path={paths.userRoutes.SEARCH_FORM} element={<SearchForm />} />
        {/* COMMENTED OUT: Routes removed as per image requirements - Menu Bar Simplification */}
        {/* <Route path={paths.userRoutes.MY_PROFILE} element={<MyProfile />} /> */}
        {/* <Route path={paths.userRoutes.ABOUT_US} element={<Aboutus />} /> */}
        {/* <Route path={paths.userRoutes.DEMO_TRAINING} element={<DemoTraining />} /> */}
        {/* <Route path={paths.userRoutes.FREE_SUBSCRIPRION} element={<FreeSubscription />} /> */}
        {/* <Route path={paths.userRoutes.BILLING} element={<Billing />} /> */}
        {/* <Route path={paths.userRoutes.SUBSCRIPRION} element={<SubscriptionPlan />} /> */}
        <Route path={paths.userRoutes.TERMS} element={<TermsOfUse />} />
        <Route path={paths.userRoutes.CONTACT_US} element={<ContactUs />} />
        <Route path={paths.userRoutes.ACCESS_ADA} element={<AccessADA />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
    // COMMENTED OUT: Token-based conditional routing removed - all users can access all pages
    // }
    // } else {
    //   if (
    //     loc.pathname === paths.userRoutes.DASHBOARD ||
    //     loc.pathname === paths.userRoutes.SEARCH_FORM ||
    //     loc.pathname === paths.userRoutes.CONTACT_US ||
    //     loc.pathname === paths.userRoutes.ACCESS_ADA ||
    //     loc.pathname === "/user/terms"
    //   ) {
    //     window.location.href = "/";
    //   } else {
    //     return (
    //       <Routes>
    //         {/* COMMENTED OUT: Login pages removed - app accessible without login */}
    //         {/* <Route path="/" element={<LoginPage />} /> */}
    //         {/* <Route path="*" element={<LoginPage />} /> */}
    //         <Route path="/" element={<Dashboard />} />
    //         <Route path="*" element={<Dashboard />} />
    //       </Routes>
    //     );
    //   }
    // }
  }
};

export default App;
